<template>
  <div
    class="rounded-circle overflow-hidden"
    :style="{
      minWidth: `${size}px`,
      width: `${size}px`,
      height: `${size}px`
    }"
  >
    <div
      v-if="img === null"
      class="bg-dark text-white font-weight-bold text-center text-uppercase"
      :style="{
        fontSize: `${size * 0.32}px`,
        lineHeight: `${size}px`
      }"
    >
      {{ abbreviation }}
    </div>
    <div v-else>
      <img :src="img" alt="test" class="img-fluid" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * size in pixel
     */
    size: {
      type: Number,
      default: 100
    },
    /**
     * firstname lastname like "Jonathan Joestar"
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * image link
     */
    img: {
      type: String,
      default: null
    }
  },

  computed: {
    abbreviation() {
      if (this.name.length === 0) return '';
      const words = this.name.split(' ');
      return words.reduce((abbr, word) => abbr.concat(word[0]), '');
    }
  }
};
</script>

<style></style>
